import get from 'lodash-es/get';
import { en } from './en';
import { zh } from './zh';
import { ja } from './ja';

import { reactive } from 'vue';

export const languages = [
  { code: 'en', label: 'English' },
  { code: 'zh', label: '中文' },
  { code: 'ja', label: '日本語' },
];

export const countryCodes = [
  { code: '+86', name: '中国', flag: '🇨🇳' },
  { code: '+1', name: '美国', flag: '🇺🇸' },
];

export const messages = {
  en: en,
  zh: zh,
  ja: ja,
  'zh-cn': zh,
  'zh-tw': zh,
};

class I18N {
  constructor(options) {
    this.options = reactive(options);
    this.global = {
      t: (key, params) => this.get(key, params),
    };
  }

  get locale() {
    return this.options.locale;
  }

  get isChinese() {
    return this.locale.toLowerCase().startsWith('zh');
  }

  get language() {
    return this.locale.split('-')[0];
  }

  t(key, params) {
    return this.get(key, params);
  }

  get(key, params, language) {
    const { locale, fallbackLocale, messages } = this.options;
    const lang = language || messages;
    const message = lang[locale];
    const fallbackMessage = lang[fallbackLocale];
    let result = get(message, key, get(fallbackMessage, key));
    if (params instanceof Object && typeof result === 'string') {
      for (const [paramKey, paramValue] of Object.entries(params)) {
        result = result.replace(new RegExp(`{{${paramKey}}}`, 'g'), paramValue);
      }
    }
    if (!result && typeof params === 'string') return params;
    return result;
  }

  setLocale(locale) {
    locale = locale.toLowerCase();
    this.options.locale = locale;
    localStorage.setItem('seede-lang', locale);
  }
}

export const i18n = new I18N({
  locale:
    localStorage.getItem('seede-lang') ||
    (navigator.language.toLowerCase().startsWith('zh') ? 'zh' : 'en'),
  fallbackLocale: 'en',
  messages: messages,
});

const urlParams = new URLSearchParams(window.location.search);

const langFromUrl = urlParams.get('lang');
if (langFromUrl) {
  i18n.setLocale(langFromUrl);
}
if (localStorage && !localStorage.getItem('seede-lang') && location.host === 'seedeai.com') {
  i18n.setLocale('zh');
}

export function t(key, v, params, lang) {
  return i18n.get(key, params, lang) || v;
}

export function $t(key, v, params, lang) {
  return i18n.get(key, params, lang) || v;
}

export default {
  install: (app) => {
    // inject a globally available $translate() method
    app.config.globalProperties.$t = (key, params, lang) => {
      if (typeof params === 'object') {
        return i18n.get(key, params, lang);
      } else if (typeof params === 'string') {
        return i18n.get(key, '', lang) || params;
      }
      return i18n.get(key, params, lang);
    };
  },
};
